module.exports = __webpack_public_path__ + "img/flowers6.3c96cd37.jpg";